
import React, { Component } from 'react';
import { Modal, Form, Input, InputNumber, DatePicker, TimePicker, Switch, Col, Row, Divider, Button, Table, Tooltip, Icon, Tag, TreeSelect } from 'antd';
import moment from 'moment';

import http from '../../../axios/http';
import messager from '../../ui/messager';
import Image from '../../ui/Image';
import DictSelect from '../../ui/DictSelect';

import AuctionLotsEdit from './AuctionLotsEdit';
import Loading from '../../ui/Loading';
import orgUtil from '../../ui/orgUtil';

//存储的全局变量
import { global_data } from '../../ui/auth';

import './AuctionStyle.css';

const fields = [{
    "text": "所属市场",
    "field": "orgCode",
    "org": true,
    rules: [
        { required: true, message: '所属市场不能为空!' },
    ]
}, {
    "text": "场次名称",
    "field": "name",
    rules: [
        { required: true, message: '场次名称不能为空!' },
        { max: 64, message: '描述信息不能超过64个字符！' },
    ]
}, {
    "text": "竞价开始时间",
    "field": "startTime",
    "date": true,
    rules: [
        { required: true, message: '竞价开始时间不能为空!' },
    ]
}, {
    "text": "展示时间",
    "field": "startShowTime",
    "date": true,
    rules: [
        { required: true, message: '展示时间不能为空!' },
    ]
}, {
    "text": "流拍时长",
    "field": "abortiveDuration",
    "time": true,
    rules: [
        { required: true, message: '流拍时长不能为空!' },
    ]
}, {
    "text": "加价倒计时",
    "field": "increaseDuration",
    "time": true,
    rules: [
        { required: true, message: '加价倒计时不能为空!' },
    ]
}, {
    "text": "竞价间隔/秒",
    "field": "intervalDuration",
    "number": true,
    rules: [
        { required: true, message: '竞价间隔不能为空!' },
    ]
}, {
    "text": "看车地点",
    "field": "viewAddr",
    rules: [
        { required: true, message: '看车地点不能为空!' },
        { max: 64, message: '看车地点不能超过64个字符！' },
    ]
}
// , {
//     "text": "是否激活",
//     "field": "state",
//     "radio": false,
// }
, {
    "text": "图片",
    "field": "image",
    image: true,
}];


class AuctionSessionEditForm extends Component {

    columns = [{
        title: '竞价品名称',
        dataIndex: 'name',
        width: 300,
        fixed: 'left',
        "className": "lots-table-td",
    }, {
        title: '竞价品编号',
        dataIndex: 'code',
        width: 150,
    }, {
        title: '车辆信息',
        dataIndex: 'vehicleIdsStr',
        width: 400,
        render: (text, record, index) => {
            if (text != null && text.length > 0) {
                text = text.replaceAll(",", "\n");
            }
            return (<Tooltip title={text}>
                <pre style={{ margin: "0px", overflow: 'visible' }}>{text}</pre>
            </Tooltip>)
        }
    }, {
        title: '起始价',
        dataIndex: 'startPrice',
        width: 100,
    }, {
        title: '保留价',
        dataIndex: 'reservePrice',
        width: 100,
    }, {
        title: '保证金',
        dataIndex: 'bond',
        width: 100,
    }, {
        title: '加价方式',
        dataIndex: 'offerDictStr',
        width: 400,
        render: (text, record, index) => {
            let tags = text == null || text === "" ? [] : text.split(",");
            return (<span>
                {tags.map(tag => {
                    return <Tag color="#108ee9" key={tag}>{tag}</Tag>
                })}
            </span>)
        }
    }, {
        title: '其他费用',
        dataIndex: 'serviceChargeDictStr',
        width: 400,
        render: (text, record, index) => {
            let tags = text == null || text === "" ? [] : text.split(",");
            return (<span>
                {tags.map(tag => {
                    return <Tag color="#108ee9" key={tag}>{tag}</Tag>
                })}
            </span>)
        }

    }, {
        title: '展示出价人',
        dataIndex: 'showBidder',
        width: 120,
        render: (text, record, index) => (
            text === 1 ? '是' : '否'
        )
    }, {
        title: '顺序号',
        dataIndex: 'sequence',
        width: 100,
    }, {
        title: '操作',
        dataIndex: 'id',
        width: 120,
        fixed: 'right',
        render: (text, record, index) => (
            <div>
                <Tooltip title="修改">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record, index)} />
                </Tooltip>
                <Tooltip title="删除">
                    <Icon type="delete" theme="filled" className="table-operate-icon" onClick={this.delete.bind(this, index)} />
                </Tooltip>

            </div>
        )
    }];

    state = {
        imageUrl: null,
        image: null,

        lotsVisible: false, //竞价品编辑窗口的展示
        lotsEditData: {},    //竞价品编辑信息
        lotsList: [],
        lotsEditIndex: null,

        loadingVisible: false,

        orgList: [],
        firstOrg: '',

        //车辆信息
        vehicleList: [],
        vehicleIdsMap: {},
        tempVehicleList: [], //用于添加竞价品页面的车辆信息
    }

    componentDidMount() {
        orgUtil.findOrg(
            { orgType: 4 },   //只查询市场会员的组织信息
            (res) => {
                let firstOrg = '';
                if (res != null && res.length > 0) {
                    firstOrg = res[0].code;
                }
                this.setState({ orgList: res, firstOrg: firstOrg });
            }
        );
        this.props.onRef(this);
    }

    initData = (editData, lotsList) => {
        let image = editData.image;
        if (image != null && image !== "") {
            image = "data:image/jpeg;base64," + image.replace(/\r\n/g, "");
        }
        this.setState({ image: image, imageUrl: editData.imageUrl, lotsList: lotsList });

        this.loadVehicleList(lotsList);
    }

    /**
     * 加载车辆信息
     */
    loadVehicleList = (lotsList) => {
        http.get({
            url: '/auctionSession/findVehicleList',
            data: {},
            success: (res) => {
                if (res != null) {
                    let vehicleIdsMap = {};
                    let vehicleList = [];
                    let vehicleIdArray = this.createVehicleIdArray(lotsList);
                    //将已经添加到竞价场次，但不在当前这个竞价场次中的车辆移除
                    for (let i = 0; i < res.length; i++) {
                        vehicleIdsMap[res[i].id] = res[i].name;
                        if (res[i].status === 'WILL_AUCTION' && vehicleIdArray.indexOf(res[i].id + "") < 0) {
                        } else {
                            vehicleList.push(res[i]);
                        }
                    }
                    this.setState({ vehicleList: vehicleList, vehicleIdsMap: vehicleIdsMap });
                }
            }
        });
    }

    /** 将选择了的竞价品列表转成车辆列表 */
    createVehicleIdArray = (lotsList) => {
        //构造当前已经添加到当前竞价场次的车辆信息
        let vehicleIdArray = [];
        if (lotsList != null && lotsList.length > 0) {
            lotsList.forEach((item, index) => {
                let vehicleIds = item["vehicleIds"];
                if (vehicleIds != null && vehicleIds.length > 0) {
                    vehicleIdArray = vehicleIdArray.concat(vehicleIds.split(","));
                }
            });
        }
        return vehicleIdArray;
    }

    save = () => {
        
        const form = this.props.form;
        form.validateFields((err, values) => {
            let startDate=values["startTime"]
            let startTime = new Date(Date.parse(startDate));
            startTime.setHours(10)
            startTime.setMinutes(0)
            let endTime = new Date(Date.parse(startDate));
            endTime.setHours(18)
            endTime.setMinutes(0)
            if(startDate<startTime||startDate>endTime){
                messager.alert("场次开始时间请设在10点-18点之间");
                return
            }
            
            if (err) {
                return;
            }
            let imageUrl = this.state.imageUrl;
            if (imageUrl != null && imageUrl !== "") {
                values["image"] = imageUrl;
            } else {
                values["image"] = this.state.image;
            }
            if (values["image"] == null || values["image"] === "") {
                messager.notify("图片不能为空！");
                return;
            }
            //根据权限判断，如果没有权限的人，则保存的时候，开始时间不能早于两个小时后
            if(!global_data.authCode.includes("AUCTION_SESSION_EDIT_ADMIN")){
                let twoHourLater = moment().add(2, "h");
                if(values["startTime"] < twoHourLater){
                    messager.notify("竞价开始时间至少比当前时间晚两小时，保存失败！");
                    return;
                }
            }

            if (values["startTime"] <= moment()) {
                messager.notify("竞价开始时间不能早于当前时间，保存失败！");
                return;
            }

            let lotsList = this.state.lotsList;
            if (lotsList == null || lotsList.length === 0) {
                messager.notify("请至少添加一个竞价品！");
                return;
            }
            let id = this.props.editData.id
            if (id !== undefined && id != null) {
                values["id"] = id;
            }
            this.setState({ loadingVisible: true });
            values["startTime"] = values["startTime"].format("YYYY-MM-DD HH:mm") + ":00";
            values["startShowTime"] = values["startShowTime"].format("YYYY-MM-DD HH:mm") + ":00";
            values["abortiveDuration"] = values["abortiveDuration"].format("HH:mm:ss");
            values["increaseDuration"] = values["increaseDuration"].format("HH:mm:ss");
            //默认未激活状态
            values["state"] =  2 ;
            

            if (lotsList != null && lotsList.length > 0) {
                values["lotsJson"] = JSON.stringify(lotsList);
            }

            http.post({
                url: '/auctionSession/saveSession',
                data: values,
                success: (res) => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    this.setState({ loadingVisible: false });
                    //判断当前保存完的场次是否已经通知了商户，如果未通知则弹窗提醒是否直接通知
                    // if (res != null && res.notice === 0 && res.state === 0 && res.status === 0) {
                    //     messager.confirm("保存成功，是否发送场次信息通知竞价会员？", () => {
                    //         this.props.noticeFunc(res.id);
                    //     }, () => {

                    //     }, "提示");
                    // } else {
                    //     messager.notify("保存成功！");
                    // }
                },
                error: (res) => {
                    this.setState({ loadingVisible: false });
                    messager.alert(res, "异常", "error");
                }
            });
        });
    };

    handleUploadImage = (field, { base64 }) => {
        this.setState({ "image": base64, "imageUrl": null });
    }
    handleRemoveImage = (field, index) => {
        this.setState({ "image": null, "imageUrl": null });
    }


    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {item.image ?
                        <Image
                            onChange={this.handleUploadImage.bind(this, item.field)}
                            onRemove={this.handleRemoveImage.bind(this, item.field)}
                            file={this.state.image}
                            text={item.text}
                            url={this.state.imageUrl}
                        />
                        : getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue:
                                item.date ? (editData[item.field] == null || editData[item.field] === "" ? null : moment(editData[item.field]))
                                    : item.time ? (editData[item.field] == null || editData[item.field] === "" ? null : moment("2020-01-01 " + editData[item.field]))
                                        : item.select ? (editData[item.field] == null || editData[item.field] === "" ? null : "" + editData[item.field])
                                            : item.radio ? editData[item.field] === 0
                                                : editData[item.field],
                            valuePropName: item.radio ? 'checked' : 'value'
                        })(
                            item.date ? <DatePicker placeholder={item.field === "startTime" ?"场次开始时间请设在10点-18点之间":null} disabledDate={item.field === "startTime" ? (current) => current && current <= moment().startOf('day') : null} format="YYYY-MM-DD HH:mm:00" showTime={{ format: 'HH:mm' }} style={{ width: '100%' }} />
                                : item.time ? <TimePicker style={{ width: '100%' }} />
                                    : item.select ? <DictSelect category={item.category} />
                                        : item.org ? <TreeSelect treeData={this.state.orgList} treeDefaultExpandAll={true} />
                                            : item.radio ? <Switch checkedChildren="是" unCheckedChildren="否" />
                                                : item.number ? <InputNumber precision={0} min={0} max={999} style={{ width: '100%' }} />
                                                    : item.textarea ? <Input.TextArea />
                                                        : <Input />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };


    create2Col = (fields) => {
        let dom = this.createDom(fields);
        let result = [];
        for (let i = 0; i < dom.length; i++) {
            let item = <Col key={i} span={11} offset={i % 2 === 0 ? 0 : 2}>{dom[i]}</Col>;
            result.push(item);
        }
        return result;
    }

    addLots = (data) => {
        let { lotsList, lotsEditIndex } = this.state;
        if (lotsEditIndex != null) {
            lotsList[lotsEditIndex] = data;
        } else {
            lotsList.push(data);
        }
        //排序
        lotsList.sort((a, b) => {
            return a.sequence - b.sequence;
        });
        lotsList.forEach((item, index) => {
            item.index = index;
        })
        this.setState({ lotsList: lotsList, lotsEditIndex: null });
    }

    add = () => {
        let lotsList = this.state.lotsList;
        this.setTempVehicleList(lotsList);
        this.setState({ lotsVisible: true, lotsEditData: {} })
    }

    setTempVehicleList = (lotsList) => {
        let vehicleIdArray = this.createVehicleIdArray(lotsList);
        let vehicleList = this.state.vehicleList;
        let tempVehicleList = [];
        //将已经添加到竞价场次，但不在当前这个竞价场次中的车辆移除
        if (vehicleList != null && vehicleList.length > 0) {
            for (let i = 0; i < vehicleList.length; i++) {
                if (vehicleIdArray.indexOf(vehicleList[i].id + "") < 0) {
                    tempVehicleList.push(vehicleList[i]);
                }
            }
        }
        this.setState({ tempVehicleList: tempVehicleList });
    }

    update = (info, index, e) => {
        let lotsList = this.state.lotsList;
        let tempLotsList = [];
        lotsList.forEach((item, i) => {
            if (i !== index) {
                tempLotsList.push(item);
            }
        });
        this.setTempVehicleList(tempLotsList);
        this.lotsRef.initData(info);
        this.setState({ lotsEditData: info, lotsVisible: true, lotsEditIndex: index });
    }

    delete = (index, e) => {
        let lotsList = this.state.lotsList;
        lotsList.splice(index, 1);
        this.setState({ lotsList: lotsList });
    }

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                width={1100}
                visible={visible}
                title="场次信息编辑"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.setState({ image: null, imageUrl: null, lotsList: [] }); this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                    <Row>{this.create2Col(fields)}</Row>
                    {/* <Row>
                        <Col span={11} >
                            <Form.Item label={"图片："}>
                                <Image
                                    onChange={this.handleUploadImage.bind(this, "image")}
                                    onRemove={this.handleRemoveImage.bind(this, "image")}
                                    file={this.state.image}
                                    text={"图片"}
                                    url={this.state.imageUrl}
                                />
                            </Form.Item>
                        </Col>
                    </Row> */}
                </Form>
                <Row>
                    <Divider orientation="left">竞价品列表</Divider>
                    <Col style={{ textAlign: "right", marginBottom: '10px' }}>
                        <Button key="take" type="primary" onClick={this.add} >添加</Button>,
                    </Col>
                    <Table
                        rowKey="index"
                        columns={this.columns}
                        dataSource={this.state.lotsList}
                        pagination={false}
                        bordered={true}
                        scroll={{ x: true }}
                    />
                </Row>
                <AuctionLotsEdit
                    visible={this.state.lotsVisible}
                    onCancel={() => { this.setState({ lotsVisible: false }) }}
                    editData={this.state.lotsEditData}
                    vehicleList={this.state.tempVehicleList}
                    vehicleMap={this.state.vehicleIdsMap}
                    successCallback={this.addLots}
                    onRef={(ref) => { this.lotsRef = ref }}
                />
                <Loading visible={this.state.loadingVisible} message="处理中，请稍候..." />
            </Modal>
        );
    }
}

const AuctionSessionEdit = Form.create()(AuctionSessionEditForm);

export default AuctionSessionEdit;